import React, { useEffect, useState } from 'react';
import { Dropdown, Menu } from 'semantic-ui-react';
import { COLORS, Text } from '@cuemath/comps';

import OptionsIcon from 'img/top-bar/options.svg';
import { get as getConfig } from 'actions/configs';
import { getAll as getPrograms } from 'actions/programs';
import { useHistory } from 'react-router-dom';
import { stringify } from 'query-string';
import { MODAL_FORM, FORM_ACTIONS } from 'constants/form';
import { openModal, closeModal } from 'actions/modal';
import { useStudentGet, invalidateStudentGet } from 'actions/studentsv2';
import { useStudentOfferPost } from 'actions/student-offers';
import { showToast } from 'actions/toast-msg';
import MODAL from 'constants/modal';
import { EVENT_TYPE } from 'constants/logger';
import { trackEvent } from 'modules/analytics';
import { USER_CONFIG, BATCHES_CONFIG, CURRENCY_OPTIONS } from 'constants/api';
import {
  Root,
  CustomeMenu,
  DefaultMenuItem,
  DefaultMenu,
  MenuItemStyle,
  VerticleSeperator,
  IconMenu,
} from './styled-comps';
import { DropdownMenu, DropdownItem, DropdownText } from 'comps/dropdown';
import { STUDENT_TAB_MENU } from './tabs';
import { useAppContext } from '../../app-context';
import { bindActionCreators } from 'redux';
import { parse } from 'query-string';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

const DEFAULT_MENU = {
  NOTES: 'notes',
  OPTIONS: 'options',
  CHAT: 'chat',
  CALL: 'call',
};

function StudentDetailsTabView({ actions, programs, studentOffers }) {
  const [selectedDefaultMenu, setSelectedDefaultMenu] = useState('');
  const history = useHistory();
  const {
    location: { search, pathname },
  } = history;

  const pathList = pathname && pathname.split('/');
  const studentId = pathList && pathList[pathList.length - 1];
  const { setSidePanelView, sidePanelView } = useAppContext();

  const { data: studentDetail } = useStudentGet(studentId);
  const {
    parent_data: parentData,
    student_offers: studentOffer,
    tablet_detected: isTabledDetected,
  } = studentDetail || {};

  const { is_deleted: isOfferDeleted, payment_id: offerPaymentId } = studentOffer || {};
  const { id: parentId } = parentData || {};

  const onSendMathCanvasOfferDetails = () => {
    trackEventFunc(EVENT_TYPE.SEND_MATH_CANVAS_OFFER_DETAILS);

    if (studentId) {
      studentOfferPost(
        {
          offer_type: 'MATH_CANVAS',
          journey_trigger_by: 'LEAP_ADMIN',
        },
        { studentId },
      );
    }
  };

  const { post: studentOfferPost } = useStudentOfferPost({
    onComplete: errorMessage => {
      if (errorMessage) {
        actions.showToast(
          'Permission error: Not authorised to initiate this action.',
          {},
          3000,
        );
      } else {
        actions.showToast('Math-Canvas offer details sent.', {}, 3000);
      }
    },
  });

  useEffect(() => {
    const { student_tab: studentTab } = parse(search);
    const tab = studentTab
      ? STUDENT_TAB_MENU.find(({ path }) => path === studentTab)
      : STUDENT_TAB_MENU[0];

    const { path } = tab || {};
    if (path) {
      history.replace({
        search: stringify({ student_tab: path }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    actions.getConfig(USER_CONFIG);
    actions.getConfig(BATCHES_CONFIG);
    actions.getConfig(CURRENCY_OPTIONS);

    if (!programs?.length) actions.getPrograms({ is_live: true });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions, studentId]);

  useEffect(() => {
    if (selectedDefaultMenu === DEFAULT_MENU.NOTES) {
      setSidePanelView({ view: 'notes', props: {}, title: 'Notes' });
    }
  }, [selectedDefaultMenu, setSidePanelView, sidePanelView]);

  function handleItemClick(_e, { name }) {
    history.replace({
      search: stringify({ student_tab: name }),
    });
  }

  function getIsActive(name) {
    return search.includes(name);
  }

  function defaultMenuClic(_e, { name }) {
    if (name === selectedDefaultMenu) {
      setSelectedDefaultMenu('');
      return;
    }

    setSelectedDefaultMenu(name);
  }

  function closeDefaultMenuClic({ name }) {
    if (name === selectedDefaultMenu) {
      setSelectedDefaultMenu('');
      return;
    }
  }

  function isDefaultMenuSelected(menu) {
    return selectedDefaultMenu === menu;
  }

  const trackEventFunc = eventType => {
    trackEvent(eventType, { parent_id: parentId, student_id: studentId });
  };

  const openEditModel = (modalName, eventType, blocking = false) => {
    trackEventFunc(EVENT_TYPE[eventType]);
    actions.openModal(
      modalName,
      {
        size: 'custom',
        width: `600px`,
        height: '400px',
        blocking,
        overflow: 'visible',
      },
      { isDefaultMenuSelected, student: studentDetail, onUpdate: () => {} },
    );
  };

  const openStudentForm = formType => {
    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      trackEventFunc(EVENT_TYPE.EDIT_STUDENT_DETAILS_CLICK);
      actions.openModal(
        MODAL_FORM.STUDENT,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          height: '90vh',
        },
        { formType, data: studentDetail },
      );
    }
  };

  const openEditCredsModal = (modalName, eventType) => {
    trackEventFunc(EVENT_TYPE[eventType]);
    actions.openModal(
      modalName,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: '350px',
      },
      {
        data: {
          parentId,
          studentId,
          onUpdate: invalidateStudentGet,
        },
      },
    );
  };

  const createDemoWithTeacher = () => {
    trackEventFunc(EVENT_TYPE.CREATE_DEMO_WITH_TEACHER_CLICK);
    actions.openModal(
      MODAL_FORM.ASSIGN_TEACHER,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.UPDATE_HEIGHT,
      },
      {
        formType: FORM_ACTIONS.CREATE,
        data: {
          ...(studentDetail || {}),
        },
        programs,
      },
    );
  };

  const onManageElectives = () => {
    trackEventFunc(EVENT_TYPE.MANAGE_ELECTIVE_COURSES_CLICK);
    actions.openModal(
      MODAL_FORM.ELECTIVE_COURSES_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: { id: studentId } },
    );
  };

  const openAssignTeacherToLead = (modalName, eventType) => {
    trackEventFunc(EVENT_TYPE[eventType]);
    actions.openModal(
      modalName,
      {
        size: 'custom',
        width: `600px`,
        height: '400px',
      },
      { student: studentDetail },
    );
  };

  const openChangeCrmParent = (modalName, eventType) => {
    trackEventFunc(EVENT_TYPE[eventType]);
    actions.openModal(
      modalName,
      {
        size: 'custom',
        width: '600px',
        height: '400px',
      },
      { student: studentDetail },
    );
  };

  const openChangeCrmGrade = (modalName, eventType) => {
    trackEventFunc(EVENT_TYPE[eventType]);
    actions.openModal(
      modalName,
      {
        size: 'custom',
        width: '600px',
        height: '400px',
      },
      { student: studentDetail },
    );
  };

  const openRenewalPlanDurations = () => {
    trackEventFunc(EVENT_TYPE.RENEWAL_PLAN_DURATIONS);
    actions.openModal(
      MODAL_FORM.RENEWAL_PLAN_DURATIONS,
      { size: 'custom', width: '560px', height: '440px' },
      { student: { id: studentId } },
    );
  };

  const onCreateDemo = () => {
    trackEventFunc(EVENT_TYPE.CREATE_TEST_SLOT_CLICK);
    actions.openModal(
      MODAL_FORM.CREATE_DEMO_SLOT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, studentId, trainingTeachers: true },
    );
  };

  const dropDownMenuList = [
    {
      dropItenText: 'Edit student details',
      dropDownAction: () => openStudentForm(FORM_ACTIONS.EDIT),
    },
    {
      dropItenText: 'Edit leap username',
      dropDownAction: () =>
        openEditModel(
          MODAL_FORM.EDIT_STUDENT_USERNAME,
          EVENT_TYPE.EDIT_LEAP_USERNAME_CLICK,
          false,
        ),
    },
    {
      dropItenText: 'Edit phone number',
      dropDownAction: () =>
        openEditModel(
          MODAL_FORM.EDIT_STUDENT_PHONE,
          EVENT_TYPE.EDIT_PHONE_NUMBER_CLICK,
          true,
        ),
    },
    {
      dropItenText: 'Edit email',
      dropDownAction: () =>
        openEditModel(MODAL_FORM.EDIT_STUDENT_EMAIL, EVENT_TYPE.EDIT_EMAIL_CLICK, true),
    },
    {
      dropItenText: 'Assign region',
      dropDownAction: () =>
        openEditCredsModal(
          MODAL_FORM.EDIT_STUDENT_REGION,
          EVENT_TYPE.ASSIGN_REGION_CLICK,
        ),
    },
    {
      dropItenText: 'Create demo with teacher',
      dropDownAction: createDemoWithTeacher,
    },
    {
      dropItenText: 'Create test/training slot',
      dropDownAction: onCreateDemo,
    },
    {
      dropItenText: 'Manage elective courses',
      dropDownAction: onManageElectives,
    },
    {
      dropItenText: 'Assign Classroom Teacher to Lead',
      dropDownAction: () =>
        openAssignTeacherToLead(
          MODAL_FORM.ASSIGN_TEACHER_TO_LEAD,
          EVENT_TYPE.ASSIGN_TEACHER_TO_LEAD,
        ),
    },
    {
      dropItenText: 'Change crm parent',
      dropDownAction: () =>
        openChangeCrmParent(MODAL_FORM.CHANGE_CRM_PARENT, EVENT_TYPE.CHANGE_CRM_PARENT),
    },
    {
      dropItenText: 'Change crm grade',
      dropDownAction: () =>
        openChangeCrmGrade(MODAL_FORM.CHANGE_CRM_GRADE, EVENT_TYPE.CHANGE_CRM_GRADE),
    },
    {
      dropItenText: 'Renewal plan durations',
      dropDownAction: openRenewalPlanDurations,
    },
  ];

  if (!isOfferDeleted && !isTabledDetected && offerPaymentId) {
    dropDownMenuList.push({
      dropItenText: 'Send Math-Canvas offer details',
      dropDownAction: onSendMathCanvasOfferDetails,
    });
  }

  return (
    <Root flexDirection="row">
      <CustomeMenu pointing secondary>
        {STUDENT_TAB_MENU.map((tab, i) => {
          const isActive = getIsActive(tab.path);
          const menuItemStyles = { ...MenuItemStyle };

          if (isActive) {
            menuItemStyles.color = COLORS.COLA;
          } else {
            menuItemStyles.color = '#2B2B2BBF';
          }

          return (
            <Menu.Item
              key={i}
              style={menuItemStyles}
              name={tab.path}
              active={isActive}
              onClick={handleItemClick}
            >
              <Text color={MenuItemStyle.color}>{tab.name}</Text>
            </Menu.Item>
          );
        })}
      </CustomeMenu>
      <DefaultMenu style={{ margin: 0 }} size="mini" secondary>
        <IconMenu position="right">
          <VerticleSeperator />
          {/**
           * TODO: uncomment following code in V2
           */}
          {/* <DefaultMenuItem
            name={DEFAULT_MENU.CALL}
            active={isDefaultMenuSelected(DEFAULT_MENU.CALL)}
            icon={true}
            onClick={defaultMenuClic}
            style={
              isDefaultMenuSelected(DEFAULT_MENU.CALL)
                ? { background: '#D9D9D9' }
                : { background: 'transparent' }
            }
          >
            <img src={PhoneIcon} />
          </DefaultMenuItem>
          <DefaultMenuItem
            name={DEFAULT_MENU.CHAT}
            active={isDefaultMenuSelected(DEFAULT_MENU.CHAT)}
            icon={true}
            onClick={defaultMenuClic}
            style={
              isDefaultMenuSelected(DEFAULT_MENU.CHAT)
                ? { background: '#D9D9D9' }
                : { background: 'transparent' }
            }
          >
            <Popup
              trigger={<img src={ChatDarkIcon} />}
              content={'Chat with parent'}
              size="mini"
              position="bottom center"
              inverted
            />
          </DefaultMenuItem>
          <VerticleSeperator />
          <DefaultMenuItem
            name={DEFAULT_MENU.NOTES}
            active={
              isDefaultMenuSelected(DEFAULT_MENU.NOTES) && sidePanelView === 'notes'
            }
            icon={true}
            onClick={defaultMenuClic}
            style={
              isDefaultMenuSelected(DEFAULT_MENU.NOTES) && sidePanelView === 'notes'
                ? { background: '#D9D9D9' }
                : { background: 'transparent' }
            }
          >
            <img src={NotesIcon} />
          </DefaultMenuItem> */}
          <DefaultMenuItem
            name={DEFAULT_MENU.OPTIONS}
            active={isDefaultMenuSelected(DEFAULT_MENU.OPTIONS)}
            icon={true}
            onClick={defaultMenuClic}
            style={
              isDefaultMenuSelected(DEFAULT_MENU.OPTIONS)
                ? { background: '#D9D9D9' }
                : { background: 'transparent' }
            }
          >
            <Dropdown
              icon={<img src={OptionsIcon} alt="" />}
              onClick={() => defaultMenuClic({}, { name: DEFAULT_MENU.OPTIONS })}
              floating
              onClose={() => closeDefaultMenuClic({ name: DEFAULT_MENU.OPTIONS })}
              className="icon"
            >
              <DropdownMenu right={'-4px'}>
                {dropDownMenuList?.map(({ dropItenText, dropDownAction }) => (
                  <DropdownItem key={dropItenText} onClick={dropDownAction}>
                    <DropdownText variant="body1Regular">{dropItenText}</DropdownText>
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </DefaultMenuItem>
        </IconMenu>
      </DefaultMenu>
    </Root>
  );
}

export default connect(
  ({ programs, studentOffers }) => {
    const programQueryParam = {
      is_live: true,
    };

    return {
      studentOffers,
      programs: store.getAll(programs, programQueryParam)?.data,
    };
  },
  dispatch => ({
    actions: bindActionCreators(
      {
        openModal,
        getConfig,
        getPrograms,
        closeModal,
        showToast,
      },
      dispatch,
    ),
  }),
)(StudentDetailsTabView);
